import {ForYouItem} from '../shared/ForYouItem'
import {ChecksSection} from './shared/ChecksSection'
import {decideChecksItem} from './shared/checks-item-decider'
import {useValidatedChecksData} from './use-validated-checks-data'
import {StatusCheckStatesIcon} from '@github-ui/mergebox/components/sections/checks/StatusCheckStatesIcon'
import {
  accessibleChecksSummary,
  checksSectionHeading,
} from '@github-ui/mergebox/components/sections/checks/checks-section-header-text'

// Renders when all checks have reached a terminal state
export function CompletedChecks() {
  const data = useValidatedChecksData()

  if (!data || decideChecksItem(data).kind !== 'completed') {
    return null
  }

  const {mergeBoxPullRequest, statusChecks, statusRollup, checksSection} = data

  return (
    <ForYouItem
      leadingVisual={<StatusCheckStatesIcon statusRollupSummary={statusRollup.summary} />}
      title={checksSectionHeading[checksSection.sectionStatus]}
      itemName="completed-checks"
      padding="none"
      description={accessibleChecksSummary(statusRollup.summary)}
    >
      <ChecksSection
        statusChecks={statusChecks}
        mergeBoxPullRequest={mergeBoxPullRequest}
        statusRollup={statusRollup}
      />
    </ForYouItem>
  )
}
